import { KgInsight, kgInsights } from '@api';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const QUERY_KEY_KG_INSIGHT = 'QUERY_KEY_KG_INSIGHT';

export const useKgInsight = (insightId: string) => {
  return useQuery({
    queryKey: [QUERY_KEY_KG_INSIGHT, insightId],
    queryFn: () => {
      const { path, schema } = kgInsights.getKgInsight;
      return wretchRequest<KgInsight>(path(insightId), {
        schema,
      });
    },
    enabled: !!insightId,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 1, // 1 hour
  });
};
